import { FC, JSX } from 'react';
import { useAuth } from 'react-oidc-context';
import { createBrowserRouter, Outlet, RouterProvider } from 'react-router';
import CssBaseline from '@mui/joy/CssBaseline';
import { Loader } from '@consolidocs-ui/components';
import AccessDenied from '_pages/Error/AccessDenied';
import useRoutes from './hooks/useRoutes';
import MainLayout from 'Components/MainLayout/MainLayout';
import { ToasterWrapper } from 'Components/ToastWrapper/ToastWrapper';

const ConsolidatesAppRoutes: FC = (): JSX.Element => {
  const auth = useAuth();
  const { routes, isLoading } = useRoutes();

  if (auth.isLoading || isLoading) {
    return <Loader />;
  }
  if (!routes || !routes.length) {
    return <AccessDenied />;
  }

  const router = createBrowserRouter([
    {
      path: '/access-denied',
      element: <AccessDenied />,
    },
    {
      path: '/',
      element: (
        <MainLayout>
          <Outlet />
        </MainLayout>
      ),
      children: routes,
    },
  ]);

  return (
    <>
      <CssBaseline />
      <ToasterWrapper />
      {auth.isLoading || isLoading ? (
        <Loader />
      ) : (
        <RouterProvider router={router} />
      )}
    </>
  );
};

export default ConsolidatesAppRoutes;
